import { getSourceType } from 'utils/assets';
import React from 'react';

type PlayerProps = {
	src: string;
	autoplay: boolean;
	muted: boolean;
	loop: boolean;
	controls: boolean;
	title?: string;
	poster?: string;
};

// https://www.youtube.com/watch?v=videoID1
// https://www.youtube.com/embed/videoID1
// http://youtu.be/videoID1
export function getYoutubeId(url: string = '') {
	const arr = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/i);
	return arr[2] !== undefined ? arr[2].split(/[^0-9a-z_-]/i)[0] : arr[0];
}

// https://vimeo.com/0000000
// https://player.vimeo.com/video/0000000
// https://player.vimeo.com/external/000000000.hd.mp4?s=181e2d4d58c43142b701c9803ed57f33cff6777b&profile_id=175
export function getVimeoId(url: string = '') {
	return url.match(/\d+/i)?.[0];
}

const getYoutubePlayerSrc = props => {
	const id = getYoutubeId(props.src);

	return id
		? `https://www.youtube.com/embed/${id}` +
				'?modestbranding=1' +
				'&playsinline=1' +
				`&loop=${props.loop ? 1 : 0}` +
				`&mute=${props.muted ? 1 : 0}` +
				`&autoplay=${props.autoplay ? 1 : 0}` +
				`&controls=${props.controls ? 1 : 0}`
		: '';
};

const getVimeoPlayerSrc = (props: PlayerProps) => {
	const id = getVimeoId(props.src);

	return id
		? `https://player.vimeo.com/video/${id}` +
				'?byline=1' +
				'&portrait=1' +
				'&autopause=1' +
				'&playsinline=1' +
				`&loop=${props.loop ? 1 : 0}` +
				`&muted=${props.muted ? 1 : 0}` +
				`&title=${props.title ? 1 : 0}` +
				`&autoplay=${props.autoplay ? 1 : 0}` +
				`&controls=${props.controls ? 1 : 0}`
		: '';
};

export const VideoPlayer = (props: PlayerProps) => {
	const type = getSourceType(props.src);
	switch (type) {
		case 'video':
			return (
				// eslint-disable-next-line jsx-a11y/media-has-caption
				<video
					title={props.title}
					src={`${props.src}#t=1`}
					poster={props.poster}
					controls={props.controls}
					muted={props.muted}
					loop={props.loop}
					preload={props.poster ? 'none' : 'metadata'}
					autoPlay={props.autoplay}
					playsInline={props.autoplay}
					controlsList="nodownload"
				/>
			);
		case 'vimeo':
			return (
				<iframe
					title={props.title}
					src={getVimeoPlayerSrc(props)}
					width="100%"
					height="100%"
					frameBorder="0"
					allowFullScreen
				/>
			);
		case 'youtube':
			return (
				<iframe
					title={props.title}
					src={getYoutubePlayerSrc(props)}
					width="100%"
					height="100%"
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				/>
			);
		default:
			return null;
	}
};

export default VideoPlayer;
